import { AfterViewInit, Component, ElementRef, EventEmitter, OnInit, Output, ViewChild, inject } from '@angular/core';
import { BaseWidgetComponent } from '../base-widget/base-widget.component';
import { WidgetService } from 'src/app/services/widget.service';
import { SelectionModel } from '@angular/cdk/collections';
import { PromptsService, PromptResponse } from 'src/app/services/prompts.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { DialogService } from '../../../services/dialog.service';

@Component({
    selector: 'app-prompts-widget',
    templateUrl: './prompts-widget.component.html',
    styleUrls: ['../base-widget/base-widget.component.scss', './prompts-widget.component.scss'],
    standalone: false
})
export class PromptsWidgetComponent extends BaseWidgetComponent implements OnInit, AfterViewInit {
  private dialogs = inject(DialogService);

  @Output() onEditFile = new EventEmitter<{ path: any }>();

  public path: string;
  public fileType: string;
  public title: string = null;
  public selectedDataset: string = null;
  public filterText = null;
  public dataSource = new MatTableDataSource<any>([]);
  public displayedColumns: string[] = ['name', 'type', 'actions'];
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild('promptsTable') promptsTable!: ElementRef;
  public pageSize = 10;

  public right = 80;
  public left = 20;
  public isLoading: boolean = true;

  constructor(
    private _widgetService: WidgetService,
    private _prompts: PromptsService,
    private _elRef: ElementRef
  ) {
    super();
    (<any>window).prompts = this;
  }

  ngOnInit(): void {
    this._subs.add = this._widgetService.resize$.subscribe((response) => {
      setTimeout(() => {
        try {
          this.optimizePageSize();
        } catch {}
      }, 100);
    });

    this.load();
  }

  private load() {
    this._prompts.load(this.teamName).subscribe((response) => {
      this.dataSource.data = <any[]>response;
      this.optimizePageSize();
      this.isLoading = false;
    });
  }

  public reloadData() {
    this.isLoading = true;
    this.load();
  }

  public ngAfterViewInit(): void {
    this.applyTableSettings();

  }

  applyTableSettings() {
    setTimeout(() => {
      this.dataSource.sort = this.sort;
      this.dataSource.paginator = this.paginator;
      this.optimizePageSize();
    }, 0);
  }

  public optimizePageSize(): void {
    let offsetHeight = this._elRef.nativeElement.offsetHeight;

    const oldPageSize = this.pageSize;
    const calcuatedPageSize = Math.floor(0.0125 * offsetHeight);
    if (calcuatedPageSize < 5) {
      this.pageSize = 5;
    } else {
      this.pageSize = calcuatedPageSize;
    }

    if (oldPageSize !== this.pageSize) {
      setTimeout(() => this.paginator._changePageSize(this.pageSize), 100);
    }
  }


  onViewData(input: any) {
    this.path = input.path;
    this.fileType = input.fileType;
    this.title = input.path.split('/').pop();
    this.widgetView = 'DETAIL';
    this.right = 100;
    this.left = 0;
  }

  onSelect(item: any, $event) {
    if (($event.target as HTMLElement).closest('button')) {
      return;
    }

    const path = item.path;
    this.onEditFile.emit({ path });
  }

  async onDelete(item: any, $event) {
    if (!await this.dialogs.confirm(`Are you sure you want to delete "${item.name}"?`)) {
      $event.stopPropagation();
      return;
    }

    this._prompts.remove(this.teamName, item.path).subscribe(() => {
      this.load();
    }, err => console.error('Error deleting prompt:', err));
    $event.stopPropagation();
  }

  async onDuplicate(item: any, $event) {
    const newName = await this.dialogs.prompt(`Enter new name for duplicate of "${item.name}":`);
    if (!newName) {
      $event.stopPropagation();
      return;
    }

    this._prompts.duplicate(this.teamName, item.path, newName).subscribe((newFile) => {
      this.load();
    }, err => console.error('Error duplicating prompt:', err));
    $event.stopPropagation();
  }

  async onAddPrompt() {
    const name = await this.dialogs.prompt('Enter name for the new prompt:');
    if (!name) {
      return;
    }

    // Use an empty string as initial content - user will edit in the editor
    const content = '';
    const type = 'txt'; // Default to txt type
    
    this._prompts.add(this.teamName, name, content, type).subscribe(
      (response) => {
        console.log('New prompt created:', response);
        this.load(); // Reload the list to show the new prompt
        
        // If we have a path in the response, open it in the editor immediately
        if (response && response.path) {
          this.onEditFile.emit({ path: response.path });
        }
      },
      (error) => {
        console.error('Error creating new prompt:', error);
        this.dialogs.alert('Failed to create new prompt. See console for details.');
      }
    );
  }


  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
    if (this.dataSource.paginator) this.dataSource.paginator.firstPage();
  }


  close() {
    if (this.widgetView === 'DETAIL') {
      this.path = null;
      this.fileType = null;
      this.title = null;
      this.widgetView = 'LIST';
      this.right = 80;
      this.left = 20;

    } else {
      super.close();
    }
  }

}
